<template>
  <el-drawer
    :title="$t('Common.detail')"
    :visible.sync="visible"
    direction="rtl"
    size="900px"
    :wrapperClosable="false"
    :close-on-press-escape="false"
    :before-close="close"
    class="product-function-detail__drawer"
  >
    <PropertyDetail v-if="row.type === 'property'" :row="row" v-bind="$attrs" />
    <ServiceDetail v-if="row.type === 'service'" :row="row" v-bind="$attrs" />
    <EventDetail v-if="row.type === 'event'" :row="row" v-bind="$attrs" />
  </el-drawer>
</template>

<script>
import PropertyDetail from './PropertyDetail'
import ServiceDetail from './ServiceDetail'
import EventDetail from './EventDetail'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object
    }
  },
  components: {
    PropertyDetail,
    ServiceDetail,
    EventDetail
  },
  data() {
    return {}
  },
  created() {},
  computed: {},
  methods: {
    close() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss" scoped></style>
